class IMInterceptor {
    constructor() {
        this.request = new InterceptorManager();
        this.response = new InterceptorManager();
    }
}
export class InterceptorManager {
    constructor() {
        this.handlers = [];
    }
    use(fullfilled) {
        const _id = `${Math.random()}`.replace('.', '');
        this.handlers.push({
            fullfilled,
            _id,
        });
        return _id;
    }
    eject(id) {
        const index = this.handlers.map(item => item === null || item === void 0 ? void 0 : item._id).findIndex(item => item === id);
        if (index === -1) {
            return;
        }
        this.handlers.splice(index, 1);
    }
    getHandlers() {
        return this.handlers;
    }
    excute(promise) {
        const handlers = [...this.handlers].filter(item => item);
        while (handlers.length) {
            const { fullfilled } = handlers.shift();
            promise = promise.then(fullfilled);
        }
        return promise;
    }
}
export default IMInterceptor;
